import moment from "moment-timezone"
import compose from "ramda/es/compose"
import identity from "lodash/identity"

export default ({ startTime, endTime, isDateOnly, defaultInterval }) => {
  const getStartTime = startTime => {
    const snapToStart = time => moment(time).startOf(`day`)

    // "Округление" даты, если событие использует только дни
    if (isDateOnly) {
      return snapToStart(startTime)
    }

    return startTime
  }

  const getEndTime = (startTime, endTime) => {
    const snapToEnd = time => {
      const isDayStart =
        moment(time)
          .startOf(`day`)
          .valueOf() === moment(time).valueOf()

      if (isDayStart) {
        return time
      }

      return moment(time)
        .add(1, `day`)
        .startOf(`day`)
    }

    const resetToDefault = () =>
      moment(startTime).add(defaultInterval, `seconds`)

    return compose(
      // "Округление" даты, если событие использует только дни
      isDateOnly ? snapToEnd : identity,
      // Установка длины события по умолчанию при наличии дефолта
      defaultInterval ? resetToDefault : identity,
    )(endTime)
  }

  const newStartTime = getStartTime(startTime)
  const newEndTime = getEndTime(newStartTime, endTime)

  return [newStartTime, newEndTime]
}
